import React from "react";
import MeasurementSlider from "../components/MeasurementSlider";
import { UncontrolledTooltip, Tooltip } from "reactstrap";
import { getDeep } from "../components/Utils";
import PropTypes from "prop-types";

class MeasurementBundle extends React.Component {
  constructor(props) {
    super(props);

    let defaultVal = 0;
    if (getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]) !== undefined) {
      defaultVal = getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]);
    }

    this.state = {
      subitemsVisible: this.props.title !== null ? false : true,
      bundleValue: defaultVal
    };

    this.handleShowSubitems = this.handleShowSubitems.bind(this);
    this.handleBundleChange = this.handleBundleChange.bind(this);
  }

  handleShowSubitems() {
    this.setState({
      subitemsVisible: !this.state.subitemsVisible
    });
  }

  handleBundleChange(value) {
    this.setState({
      bundleValue: value
    });

    if (this.props.linkedMeasurements !== undefined) {
      this.props.linkedMeasurements.forEach((linkedMeasurement) => {
        this.props.addMeasurement(this.props.params.eventId, this.props.student.uuid, linkedMeasurement, value);
      });
    }
  }

  render() {
    var items = [];
    let currentEvent = this.props.events[this.props.params.eventId];

    this.props.measurementSliders.forEach((measurement) => {
      items.push(
        <MeasurementSlider
          {...this.props}
          title={measurement.name}
          description={measurement.description}
          indented={this.props.title !== null ? true : false}
          linkedMeasurements={[]}
          uuid={measurement.uuid}
          props={this.props.readonly || false}
          key={"measurement" + measurement.uuid}
        />
      );
    });

    var toggleType = (
      <span>
        <i className="fa fa-toggle-off"></i>
      </span>
    );
    if (this.state.subitemsVisible) {
      var toggleType = (
        <span>
          <i className="fa fa-toggle-on"></i>
        </span>
      );
    }

    var sliderVisible = "measurement-bundle-sliders";
    if (this.state.subitemsVisible) {
      sliderVisible += " visible";
    }

    var tooltipItem = null;
    if (this.props.description !== undefined && this.props.description.length > 3) {
      tooltipItem = (
        <div>
          <span className="show-tooltip" id={"tooltiptrigger" + this.props.uuid}>
            <i className="fa fa-info-circle"></i>
          </span>
          <UncontrolledTooltip placement="left" target={"tooltiptrigger" + this.props.uuid} className="measurement-tooltip">
            {this.props.description}
          </UncontrolledTooltip>
        </div>
      );
    }

    let bundle = "";
    if (this.props.title !== null) {
      let defaultValue = this.state.bundleValue;
      if (getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]) !== undefined) {
        defaultValue = getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]);
      }

      bundle = (
        <div>
          <div className="measurement-bundle-toggle" onClick={this.handleShowSubitems}>
            {tooltipItem}
            {toggleType} {this.props.title}
          </div>

          <MeasurementSlider
            {...this.props}
            title=""
            uuid={this.props.uuid}
            key={"bundle" + this.props.student.uuid + "-" + this.props.uuid}
            value={defaultValue}
            linkedMeasurements={this.props.linkedMeasurements}
            callbackParent={this.handleBundleChange}
          />
        </div>
      );
    }

    return (
      <div className="measurement-bundle">
        {bundle}

        <div className={sliderVisible}>{items}</div>
      </div>
    );
  }
}

MeasurementBundle.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.number,
  measurementSliders: PropTypes.array
};

MeasurementBundle.defaultProps = {
  title: "",
  measurementSliders: []
};

export default MeasurementBundle;



// WEBPACK FOOTER //
// ./components/MeasurementBundle.js